import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import { OCTADESK_CHAT_OPEN_CLASS } from '../constants/octadeskConstants'

const useOctadeskChatStore = defineStore('support/octadesk-chat', () => {
  const isOpen = ref(false)
  const openRequested = ref(false)

  function setOpen (open: boolean): void {
    if (
      isOpen.value === open &&
      document.documentElement.classList.contains(OCTADESK_CHAT_OPEN_CLASS) === open
    ) {
      return
    }

    isOpen.value = open
    document.documentElement.classList.toggle(OCTADESK_CHAT_OPEN_CLASS, open)
  }

  function markOpenRequested (): void {
    openRequested.value = true
  }

  function clearOpenRequested (): void {
    openRequested.value = false
  }

  function reset (): void {
    openRequested.value = false
    setOpen(false)
  }

  return {
    isOpen,
    openRequested,
    setOpen,
    markOpenRequested,
    clearOpenRequested,
    reset
  }
})

export default useOctadeskChatStore

/* c8 ignore next 3 */
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useOctadeskChatStore, (import.meta as any).hot))
}
